import { render, staticRenderFns } from "./ContaPagar.vue?vue&type=template&id=47d9dc0a&"
import script from "./ContaPagar.vue?vue&type=script&lang=js&"
export * from "./ContaPagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports